import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Check, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import CollapsibleSection from '@/components/superuser/CollapsibleSection';

interface Props {
  briefing: string | undefined;
}

export default function BriefingPanel({ briefing }: Props) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    if (!briefing) return;
    try {
      await navigator.clipboard.writeText(briefing);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // sin feedback adicional; el usuario puede seleccionar manualmente
    }
  };

  const copyButton = (
    <Button variant="outline" size="sm" onClick={onCopy} disabled={!briefing}>
      {copied ? (
        <>
          <Check className="mr-1 size-4" />
          {t('superuser.debug.detail.briefing.copied', 'Copiado')}
        </>
      ) : (
        <>
          <Copy className="mr-1 size-4" />
          {t('superuser.debug.detail.briefing.copy', 'Copiar')}
        </>
      )}
    </Button>
  );

  return (
    <CollapsibleSection
      title={t('superuser.debug.detail.briefing.title', 'Briefing generado')}
      headerExtra={copyButton}
    >
      {briefing ? (
        <pre className="max-h-[480px] overflow-auto rounded-md border bg-muted/30 p-3 font-mono text-xs leading-relaxed whitespace-pre-wrap break-words">
          {briefing}
        </pre>
      ) : (
        <p className="text-sm text-muted-foreground">
          {t('superuser.debug.detail.briefing.empty', 'No hay briefing persistido para esta sesión.')}
        </p>
      )}
    </CollapsibleSection>
  );
}
